var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('psi-detail-card',{attrs:{"items":_vm.items,"headingTitle":"Court Case","icon":"mdi-scale-balance"}})}
var staticRenderFns = []

export { render, staticRenderFns }